import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=28626e58&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=28626e58&lang=scss"
import style1 from "./notice.vue?vue&type=style&index=1&id=28626e58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28626e58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28626e58')) {
      api.createRecord('28626e58', component.options)
    } else {
      api.reload('28626e58', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=28626e58&scoped=true", function () {
      api.rerender('28626e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/notice.vue"
export default component.exports